import { NPIDataGridColDef, NPIDataGridRow } from 'src/components/NPIDataGrid/NPIDataGrid';

import BugsnagPerformance from './config/client';
import { PERFORMANCE_CONFIG, PERFORMANCE_SPANS } from './constants';

export const startSpan = (name: string) => {
    if (!PERFORMANCE_CONFIG.isEnabled) {
        return {
            setAttribute: () => {},
            end: () => {},
        };
    }
    return BugsnagPerformance.startSpan(name);
};

export const initializePerformanceTracking = (
    rows: NPIDataGridRow[],
    columns: NPIDataGridColDef[],
    paginationMode: string,
    filtering: { isEnabled: boolean },
    serverSideSorting: any
) => {
    const span = startSpan(PERFORMANCE_SPANS.NPI_DATA_GRID.LOAD);
    span.setAttribute('row.count', rows.length);
    span.setAttribute('column.count', columns.length);
    span.setAttribute('pagination.mode', paginationMode);
    span.setAttribute('filtering.enabled', Boolean(filtering?.isEnabled));
    span.setAttribute('sorting.enabled', Boolean(serverSideSorting !== null));
    span.end();
};

export const withAsyncSpan = <T extends unknown[], R>(
    spanName: string,
    callback: (...args: T) => Promise<R>
) => {
    return async (...args: T): Promise<R> => {
        const span = startSpan(spanName);
        try {
            const result = await callback(...args);
            span.end();
            return result;
        } catch (error) {
            span.end();
            throw error;
        }
    };
};

export const withSpan = <T extends unknown[], R>(spanName: string, callback: (...args: T) => R) => {
    return (...args: T): R => {
        const span = startSpan(spanName);
        try {
            return callback(...args);
        } finally {
            span.end();
        }
    };
};
